import { render, staticRenderFns } from "./Hardknockout.vue?vue&type=template&id=1a81c1b8&"
import script from "./Hardknockout.vue?vue&type=script&lang=js&"
export * from "./Hardknockout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports